<template>
  <div class="gatherManageApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="meheader" v-if="setLeader != null">
      <div class="headMe">
        <img :src="setLeader.avatar" />
        <div class="right">
          <h2>{{setLeader.username}}</h2>
          <p>{{setLeader.phone}}</p>
        </div>
      </div>
      <ul>
        <li>
          <h3>{{setLeader.useMoney}}</h3>
          <div>总收入</div>
        </li>
        <li>
          <h3>{{setLeader.total}}</h3>
          <div>实体卡数量</div>
        </li>
        <li>
          <h3>{{setLeader.useTotal}}</h3>
          <div>已领取</div>
        </li>
        <li>
          <h3>{{setLeader.total - setLeader.useTotal}}</h3>
          <div>剩余卡数</div>
        </li>
      </ul>
    </div>

    <ol v-if="setGather.length > 0">
      <li v-for="(item,i) in setGather">
        <h2>{{item.title}}</h2>
        <p>有效时间：{{item.starttime}} ~ {{item.endtime}}</p>
        <p>实体卡数量：{{item.total}}张</p>
        <p>已领取数量：{{item.useTotal}}张</p>
        <div class="expired" >剩余{{item.total - item.useTotal}}张</div>
        <a @click="$router.push('gathercard?id='+item.id)">查看<i class="el-icon-arrow-right"></i></a>
        <a style="right:90px;width:80px" @click="$router.push('gathernum?id='+item.id)">入园次数<i class="el-icon-arrow-right"></i></a>
      </li>
    </ol>
    <div v-if="setLeader == null" style="text-align:center;font-size:14px;color:#6b6b6b;padding-top:60%">暂无数据~</div>
  </div>
</template>

<script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        userData:[],
        setLeader:[],
        setGather:[]
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    mounted() {
      this.beforeMount();
      this.getLeader();
    },
    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      getLeader:function(){
        var that = this;
        $.ajax({
          type:'post',
          url:that.$host+'home/gather/getLeader',
          data:{
            user_id:that.userData.id,
          },
          dataType:'json',
          success:function(data){
            that.setLeader = data.data
            if(data.data != null){
              that.getGather();
            }
          }
        })
      },
      getGather:function(){
        var that = this;
        $.ajax({
          type:'post',
          url:that.$host+'home/gather/getGather',
          data:{
            user_id:that.userData.id,
          },
          dataType:'json',
          success:function(data){
            that.setGather = data.data
          }
        })
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .gatherManageApp{
    max-width:640px;
    background:#ececec;
    margin:0 auto;
  }
  .gatherManageApp .meheader{
    background: linear-gradient(90deg, #61BEFF, #4F7CFF);
  }
  .gatherManageApp .headMe{
    width:92%;
    margin:0 auto;
    padding:15px 0;
    position:relative;
  }
  .gatherManageApp .headMe:after,.gatherManageApp ul:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .gatherManageApp .headMe img{
    width:60px;
    border-radius:100%;
    float:left;
  }
  .gatherManageApp .headMe .right{
    float:left;
    width:75%;
    margin-left:3%;
  }
  .gatherManageApp .headMe .right h2{
    font-size:18px;
    padding:7px 0 5px 0;
    color:#fff
  }
  .gatherManageApp .headMe .right h2 input{
    font-weight:normal;
    font-size:12px;
    color:#FF6600;
    border:none;
    width:65px;
    background:none;
    outline:none;
  }
  .gatherManageApp .headMe .right p{
    font-size:15px;
    color:#555;
    color:#fff
  }
  .gatherManageApp .headMe .setTake{
    color:#fff;
    font-size:22px;
    right:0;
    top:25px;
    position:absolute;
  }
  .gatherManageApp ul{
    clear:both;
    padding:0px 0 12px 0;
    width:100%
  }
  .gatherManageApp ul li{
    float:left;
    width:25%;
    position:relative;
  }
  .gatherManageApp ul li:after{
    position:absolute;
    content:'';
    width:1px;
    height:30px;
    background:#61BEFF;
    right:0;
    top:50%;
    transform: translateY(-50%);
  }
  .gatherManageApp ul li:last-child:after{
    background:#4F7CFF;
  }
  .gatherManageApp ul li h3{
    text-align:center;
    font-size:15px;
    color:#fff
  }
  .gatherManageApp ul li div{
    text-align:center;
    font-size:11px;
    color:#666;
    padding-top:3px;
    color:#fff
  }


  .gatherManageApp ol{
    width:100%;
    margin:0 auto;
  }
  .gatherManageApp ol li{
    background:#fff;
    margin-bottom:10px;
    padding:12px;
    position:relative;
  }
  .gatherManageApp ol li h2{
    font-size:16px;
    color:#1C222B
  }
  .gatherManageApp ol li p{
    font-size:14px;
    color:#3b3b3b;
    padding-top:6px
  }
  .gatherManageApp ol li .expired{
    font-weight: bold;
    font-size: 14px;
    color: #E34D59;
    padding-top:6px
  }
  .gatherManageApp ol li a{
    bottom:15px;
    right:15px;
    position:absolute;
    border: 1px solid #0052D9;
    border-radius: 3px;
    width: 64px;
    font-size: 14px;
    color: #0052D9;
    text-align:center;
    height: 24px;
    line-height: 25px;
  }
</style>